<template>
  <div style="margin: 0 auto 5rem; max-width: 960px;">
    <div class="dashboard-title">
      <BackButton link="/contact-requests" text="Back to Contact requests" />
      <div style="display: flex; align-items: center; margin-bottom: 1.5rem;">
        <h1 class="fw-bold fs-xl">
          Contact request from {{ contactDetail.companyName }}
        </h1>
        <div class="badge" :class="contactDetail.status | statusClass">
          {{ contactDetail.status | status }}
        </div>
        <div
          v-if="contactDetail.status == 'A' && leadFlowEnabled"
          class="badge adjust-ml"
          :class="contactDetail.projectStatus | projectClass"
        >
          {{ contactDetail.projectStatus | projectStatus }}
        </div>
      </div>
    </div>
    <div>
      <template>
        <SectionHeading
          heading="Request details"
          description="Information submitted about the customer who needs services rendered"
          style="margin-top: 0;"
        />
        <Card>
          <div class="grid">
            <div
              class="grid__cell col12-of-12--large-up"
              style="margin-bottom: 0;"
            >
              <div class="grid">
                <div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Request date:
                    </p>
                    <p class="fs-sm theme-text-medium">{{ date }}</p>
                  </div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      partner:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ contactDetail.resellerName }}
                    </p>
                  </div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Contact person:
                    </p>
                    <p class="fs-sm theme-text-medium">{{ name }}</p>
                    <p class="fs-sm theme-text-medium">
                      {{ contactDetail.email }}
                    </p>
                  </div>
                  <div class="grid__cell col4-of-12--large-up mb-sm">
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Company name:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ contactDetail.companyName }}
                    </p>
                  </div>
                  <div
                    v-if="contactDetail.companyWebsite"
                    class="grid__cell col4-of-12--large-up mb-sm"
                  >
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Company website:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ contactDetail.companyWebsite }}
                    </p>
                  </div>
                  <div
                    class="grid__cell col4-of-12--large-up mb-sm"
                    v-if="location"
                  >
                    <p class="theme-text-dark fw-semibold fs-sm mb-xs">
                      Company location:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ location }}
                    </p>
                  </div>
                  <div
                    v-for="(item, i) in services"
                    :key="i"
                    class="grid__cell col4-of-12--large-up mb-sm"
                  >
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      {{ item.filter_name }}:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ item.options | options }}
                    </p>
                  </div>
                  <div
                    class="grid__cell col12-of-12--large-up"
                    :style="
                      !contactDetail.accountEmail ? 'marginBottom: 0' : ''
                    "
                    v-if="contactDetail.comments"
                  >
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      comments:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ contactDetail.comments }}
                    </p>
                  </div>
                  <div
                    v-if="contactDetail.accountEmail"
                    class="grid__cell col4-of-12--large-up"
                    style="margin-bottom: 0;"
                  >
                    <p
                      class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
                    >
                      Zapier Account Email:
                    </p>
                    <p class="fs-sm theme-text-medium">
                      {{ contactDetail.accountEmail }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="contactDetail.createdFromMatch"
              class="line-separator"
            ></div>
            <div
              v-if="contactDetail.createdFromMatch"
              class="grid__cell col12-of-12--large-up"
              style="margin-bottom: 0; margin-top:1rem"
            >
              <span
                class="f-capitalize theme-text-dark fw-semibold fs-sm mb-xs"
              >
                Source:
              </span>
              <span class="fs-sm theme-text-medium">
                Matchmaking request
              </span>
            </div>
          </div>
        </Card>
      </template>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatDate } from '@/utils/date';
import SectionHeading from '@/components/DesignSystem/SectionHeading';
import Card from '@/components/DesignSystem/Card';
import BackButton from '@/components/BackButton';

const { mapGetters, mapActions } = createNamespacedHelpers(
  'contactRequests/detail'
);

const location_filter = 'Company location';
export default {
  name: 'ContactDetail',
  components: {
    SectionHeading,
    Card,
    BackButton,
  },
  filters: {
    status(value) {
      switch (value) {
        case 'A':
          return 'Accepted';
        case 'R':
          return 'Declined';
        default:
          return 'Pending';
      }
    },
    statusClass(value) {
      switch (value) {
        case 'A':
          return 'accepted';
        case 'R':
          return 'declined';
        default:
          return 'pending-status';
      }
    },
    projectStatus(value) {
      switch (value) {
        case 'C':
          return 'Lead contacted';
        case 'L':
          return 'Lead lost';
        case 'S':
          return 'Project secured';
        default:
          return 'New lead';
      }
    },
    projectClass(value) {
      switch (value) {
        case 'C':
          return 'lead-contacted';
        case 'L':
          return 'lead-lost';
        case 'S':
          return 'project-secured';
        default:
          return 'new-lead';
      }
    },
    options: function(value) {
      if (typeof value === 'string') {
        return value;
      }

      let string = '';
      value.forEach(item => {
        string += `${item}, `;
      });
      return string.slice(0, -2);
    },
  },
  computed: {
    ...mapGetters(['contactDetail']),
    name() {
      return this.contactDetail.firstName + ' ' + this.contactDetail.lastName;
    },
    agencyLeadsEnabled() {
      return this.$store.getters['details'].agencyLeadViewEnabled;
    },
    leadFlowEnabled() {
      return this.$store.getters['details'].leadFlowEnabled;
    },
    date() {
      return this.contactDetail.created
        ? formatDate(new Date(String(this.contactDetail.created)))
        : '-';
    },
    services() {
      if (typeof this.contactDetail.services !== 'string') return [];
      return JSON.parse(this.contactDetail.services).filter(s => {
        if (s.filter_name !== location_filter) {
          let options = null;
          if (Array.isArray(s.options)) {
            options = s.options.length > 0 ? s.options : null;
          } else {
            options = s.options;
          }
          if (options) {
            s.options = options;
            return s;
          }
        }
      });
    },
    location() {
      const services = this.contactDetail.services;
      if (services && typeof services === 'string' && JSON.parse(services)) {
        const location = JSON.parse(services).find(
          s => s.filter_name === location_filter
        );
        if (location) {
          return location.options;
        }
      }
      return '';
    },
  },
  methods: {
    ...mapActions(['fetchContactDetail']),
  },
  mounted() {
    this.fetchContactDetail(this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
.grid .grid__cell {
  margin-bottom: 1.25em;

  .f-capitalize {
    margin-bottom: 0.33em;
  }
}
.line-separator {
  border-top: 2px solid #e5e7eb;
  margin-right: -1.3rem;
  margin-left: -0.3rem;
  margin-top: 1.3rem;
}
.badge {
  padding: 2px 12px;
  border-radius: 999px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  margin-left: 16px;
  color: #202223;

  &.adjust-ml {
    margin-left: 8px;
  }

  &.pending-status,
  &.new-lead {
    background-color: #fff;
  }

  &.accepted,
  &.project-secured {
    background-color: #aee9d1;
  }
  &.declined,
  &.lead-lost {
    background-color: #ffd79d;
  }
  &.lead-contacted {
    background-color: #a4e8f2;
  }
}
</style>
